import { LegalLayout, CONTACT, H2 } from "./LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" updated="June 2026" testid="terms-page">
      <p>
        These Terms of Service ("Terms") govern your use of the website and SMS messaging services provided by{" "}
        {CONTACT.name} ("Pinpoint Media Intelligence", "we", "us", or "our"). By using our services, you agree to
        these Terms.
      </p>

      <H2>Eligibility</H2>
      <p data-testid="terms-age-clause">
        You must be at least 18 years of age to use our services and to opt in to receive SMS communications.
      </p>

      <H2>SMS / Text Messaging Program</H2>
      <p>
        By providing your mobile number and checking the SMS consent box, you consent to receive recurring SMS
        communications from Pinpoint Media Intelligence related to local deals, offers, and account notifications.
      </p>
      <ul className="list-disc pl-6 space-y-1">
        <li><span className="font-[600]">Message frequency:</span> Message frequency varies.</li>
        <li><span className="font-[600]">Rates:</span> Message &amp; data rates may apply.</li>
        <li><span className="font-[600]">Opt out:</span> Reply STOP at any time to cancel.</li>
        <li><span className="font-[600]">Help:</span> Reply HELP for assistance, or contact us at {CONTACT.email}.</li>
      </ul>
      <p data-testid="terms-carrier-clause">
        T-Mobile and other wireless carriers are not liable for delayed or undelivered messages.
      </p>

      <H2>Acceptable Use</H2>
      <p>
        You agree not to misuse our services, interfere with their operation, or use them for any unlawful purpose.
        We may suspend or terminate access to our services at our discretion.
      </p>

      <H2>Disclaimers and Limitation of Liability</H2>
      <p>
        Our services are provided "as is" without warranties of any kind. To the fullest extent permitted by law,
        Pinpoint Media Intelligence shall not be liable for any indirect, incidental, or consequential damages
        arising from your use of our services.
      </p>

      <H2>Changes to These Terms</H2>
      <p>
        We may update these Terms from time to time. Continued use of our services after changes become effective
        constitutes acceptance of the revised Terms.
      </p>

      <H2>Contact Us</H2>
      <p>
        {CONTACT.name}<br />
        {CONTACT.address}<br />
        Email: <a href={`mailto:${CONTACT.email}`} className="underline text-navy-900">{CONTACT.email}</a>
      </p>
    </LegalLayout>
  );
}
